import { DropdownEditor, DropdownListItemProps } from '@approvalmax/ui';
import { memo } from 'react';

import { ClearingSystemListItemData } from '../../AddBeneficiaryPopup.types';
import { Root } from './ClearingSystemListItem.styles';

const ClearingSystemListItem = memo<DropdownListItemProps<ClearingSystemListItemData>>((props) => {
    return (
        <DropdownEditor.ListItem {...props}>
            {(text, item: ClearingSystemListItemData) => {
                return (
                    <Root>
                        <b>{text}</b>

                        <div>{item.description}</div>
                    </Root>
                );
            }}
        </DropdownEditor.ListItem>
    );
});

export default ClearingSystemListItem;
